module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c3MC9"))).then(() => parcelRequire('fThBo'));